import { store } from '@/store';
import i18n from '@/i18n';
import moment from 'moment';
import nl2br from 'nl2br';
import numeral from 'numeral';
import Vue from 'vue';

Vue.filter('truncate', function(val, len, suffix = '...') {
    if (val === undefined || val === null || val === '') return '';
    return val.length > len ? val.substring(0, len) + suffix : val;
});

Vue.filter('day', function(val, format = 'dddd') {
    moment.locale(store.getters.lang);
    const day = moment().day(val).format(format);
    moment.locale('en');
    return day;
});

Vue.filter('time', function(val) {
    moment.locale(store.getters.lang);
    const time = moment(val, 'HH:mm').format('h:mm A');
    moment.locale('en');
    return time;
});

Vue.filter('date', function(val, format = 'MMM D, Y', lang = 'en') {
    moment.locale(store.getters.lang);
    const date = val ? moment.unix(val).format(format) : '';
    moment.locale('en');
    return date;
});

Vue.filter('dateTime', function(val, format = 'MMM D, Y h:mm A', lang = 'en') {
    moment.locale(store.getters.lang);
    const dateTime = val ? moment.unix(val).format(format) : '';
    moment.locale('en');
    return dateTime;
});

Vue.filter('relativeTime', function(val) {
    moment.locale(store.getters.lang);
    const relativeTime = val ? moment.unix(val).fromNow() : '';
    moment.locale('en');
    return relativeTime;
});

Vue.filter('numeral', function(val, format = '0,0') {
    return numeral(String(val)).format(format);
});

Vue.filter('currency', function(val) {
    return val ? numeral(val / 100).format('$0,0.00') : '$0.00';
});

Vue.filter('currencyForProject', function(val) {
    const params = {
        style: 'currency',
        currency: store.getters.project.currency
    };
    val = parseFloat((val || 0) / 100);
    return new Intl.NumberFormat('en-US', params).format(val);
});

Vue.filter('paginationTitle', function(val, prefix = '', loadedCount = null) {
    if (!val || !val.total) return prefix;
    const from = loadedCount != null ? 1 : val.from;
    const to = loadedCount != null ? Math.min(loadedCount, val.total) : val.to;
    let str = '';
    str += numeral(from).format('0,0');
    str += ' - ';
    str += numeral(to).format('0,0');
    str += ' ' + i18n.t('labels.of') + ' ';
    str += numeral(val.total).format('0,0');
    return prefix.length ? prefix + ` (${str})` : str;
});

Vue.filter('capitalize', function(val) {
    return val[0].toUpperCase() + val.slice(1);
});

Vue.filter('urldecode', function(val) {
    return decodeURIComponent(val.replace(/\+/g, ' '));
});

Vue.filter('nl2br', function(val) {
    return nl2br(val);
});